import invariant from "tiny-invariant";

import {
  DateRangeParams,
  useDateRangeParams,
} from "@/common/hooks/use-date-range-params";

import {
  getAvailableFilters,
  getFilterByDateRange,
  getFilterParams,
} from "./quick-filters.utils";

const useCurrentDateRange = () => {
  const dateFilters = getAvailableFilters();
  const searchParams = useDateRangeParams();
  const currentDateFilter = getFilterByDateRange(
    dateFilters,
    getFilterParams(searchParams as DateRangeParams),
  );
  invariant(currentDateFilter?.dateFrom);
  invariant(currentDateFilter.dateTo);

  return {
    dateFrom: currentDateFilter.dateFrom,
    dateTo: currentDateFilter.dateTo,
  };
};

export { useCurrentDateRange };
